var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let properties = options.propertyData.properties;
 let ab_test_flag = options.ab_test_srp;
 let srp_view_type = options.srp_view_type;
 let ab_similar_homes_type = options.ab_similar_homes_type
 let cssForComparable = options.cssForComparable
 let convertToInteger = options.convertToInteger
 let findSubString = options.findSubString
 let price_class, sqft_class, lot_class, year_class

__p+='\n\n';
 if (properties && properties.length) { 
__p+='\n<h2 class="title-section">\n  <i class="ra ra-similar-homes"></i>Similar homes\n</h2>\n<i id="similar-homes-close" class="ra ra-close-thin"></i>\n<div class="component_bm-carousel">\n  <div class="rdc-carousel">\n    <div class="owl-carousel">\n      ';
 properties.forEach((property, listing_index) => { 
__p+='\n      ';
 listing_index += 2500 
__p+='\n      ';

          if(property.compared_price == 'Similar priced') {
            property.compared_price = 'Similar price';
            price_class = 'even';
          } else {
            price_class = cssForComparable(convertToInteger(MOVE_DATA.adobeDTM.listingPrice), convertToInteger(property.price));
          }
          if(property.compared_sqft) {
            property.compared_sqft = property.compared_sqft.replace("sq ft", "sqft");
          }
          sqft_class  = cssForComparable(convertToInteger(MOVE_DATA.adobeDTM.listingSqFt), convertToInteger(property.sqft));
          if (property.compared_lot_size) {
            lot_class   = (findSubString(property.compared_lot_size, 'small')) ? 'arrow-down' : 'arrow-up';
          }
          if (property.compared_year_built) {
            year_class  = (findSubString(property.compared_year_built, 'old')) ? 'arrow-down' : 'arrow-up';
          }
          
__p+='\n      '+
((__t=( JST["quick_view/templates/similar-home/similar-hm-browse-module-card"]({property, listing_index, ab_test_flag, srp_view_type, ab_similar_homes_type, price_class, sqft_class, lot_class, year_class}) ))==null?'':__t)+
'\n      ';
 }) 
__p+='\n    </div>\n    <div class="rdc-carousel-nav improve_similar_hm">\n      <div class="rdc-prev-set hide"><i class="ra ra-angle-left"></i></div>\n      <div class="rdc-next-set hide"><i class="ra ra-angle-right"></i></div>\n    </div>\n  </div>\n</div>\n';
 }
__p+='';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/similar-home/similar-homes-carousel.jst.ejs